module.exports = __webpack_public_path__ + "static/img/093_TO8_1762.27b1e62.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/093_TO8_1762.jpg
// module id = oDMz
// module chunks = 0